import { render, staticRenderFns } from "./Add_License.vue?vue&type=template&id=7f5a47f4&scoped=true&"
import script from "./Add_License.vue?vue&type=script&lang=js&"
export * from "./Add_License.vue?vue&type=script&lang=js&"
import style0 from "./Add_License.vue?vue&type=style&index=0&id=7f5a47f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a47f4",
  null
  
)

export default component.exports